import React from 'react'
import { Controller } from 'react-hook-form'

import Checkbox from '../../../../components/Input/Checkbox'

const Notification = ({ notificationsSetting, control }) => {
  return (
    <div className="w-full flex flex-col items-start">
      <h4 className="text-base text-primary-100 font-bold">{notificationsSetting.title}</h4>

      <div className="flex flex-col gap-y-[20px] mt-[10px]">
        {notificationsSetting.options.map((option) => {
          return (
            <Controller
              key={option.value}
              control={control}
              name={option.value}
              render={({ field: { value, onChange } }) => {
                return (
                  <Checkbox
                    label={option.label}
                    className="text-primary-100 text-sm font-normal"
                    checked={value}
                    onChange={onChange}
                  />
                )
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

export default Notification
